<template>
  <div class="lz-field">
    <label class="lz-field-label" for="hoursVal">Hours</label>
    <input
      type="number"
      id="hoursVal"
      max="18"
      class="form-control"
      placeholder="1"
      v-model="duration"
      @keyup="pickDuration" />
  </div>
</template>

<script>
export default {
  name: 'HoursSelector',
  computed: {
    FormData() {
      return this.$store.getters.formData
    },
    duration() {
      return this.FormData.duration
    }
  },
  methods: {
    pickDuration(ev) {
      let numReg = new RegExp('^[0-9]+$|^[0-9]+?\\.[1-9]$', 'g')
      let val = parseFloat(ev.target.value)
      let isValid = numReg.test(String(val))
      if (!isValid) {
        ev.target.value = ''
      }
    }
  }
}
</script>
